import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ConfigProvider, theme } from 'antd'
import ruRU from 'antd/locale/ru_RU'
import dayjs from 'dayjs'
// Русская локаль для всего интерфейса antd: календари, пагинация, пустые
// состояния. dayjs задаётся отдельно - на нём построены DatePicker.
import 'dayjs/locale/ru'
import { ThemeProvider, useTheme } from './contexts/ThemeContext'
import App from './App'
import './styles/globals.css'

dayjs.locale('ru')


const ThemedApp = () => {

    const { theme: currentTheme } = useTheme()
    const isDark = currentTheme === 'dark'

    return (
        <ConfigProvider
            locale={ruRU}
            theme={{
                algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
                token: {
                    colorPrimary: '#0088cc',
                    colorInfo: '#0088cc',
                    borderRadius: 12,
                    colorBgContainer: isDark ? '#14141f' : '#ffffff',
                    colorBgElevated: isDark ? '#1c1c2a' : '#ffffff',
                    colorBgLayout: isDark ? '#0c0c14' : '#f8fafc',
                    colorBorder: isDark ? '#2a2a3a' : '#e2e8f0',
                    colorText: isDark ? '#f8fafc' : '#0f172a',
                    colorTextSecondary: isDark ? '#94a3b8' : '#475569',
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
                },
                components: {
                    Button: {
                        borderRadius: 12,
                        controlHeight: 44,
                        fontWeight: 600,
                    },
                    Input: {
                        borderRadius: 12,
                        controlHeight: 44,
                    },
                    Select: {
                        borderRadius: 12,
                        controlHeight: 44,
                    },
                    Card: {
                        borderRadius: 16,
                    },
                    Modal: {
                        borderRadius: 20,
                    },
                    Table: {
                        borderRadius: 16,
                    },
                    Menu: {
                        itemBorderRadius: 12,
                    },
                },
            }}
        >
            <App />
        </ConfigProvider>
    )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <BrowserRouter>
            <ThemeProvider>
                <ThemedApp />
            </ThemeProvider>
        </BrowserRouter>
    </React.StrictMode>,
)
